export default __webpack_public_path__ + "static/media/scrappy3.f43505da.png";